import { Injectable} from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

import { AppConfig } from '../config/app.config';
import { IReturnObject } from '../shared/return-object.model';

@Injectable()
export class PartSupplierPruService {
    constructor(private config: AppConfig, private http: Http) {}

    private apiUrl: string = this.config.get( 'apiUrl' ) + 'Part';
    private apiNotImplementedUrl: string = this.config.get( 'apiUrl' ) + 'NotImplementedYet';

    searchPruByPruNameFor( partNo: string ): Observable<IReturnObject> {
        return this.http.get( `${this.apiUrl}/SearchPruByPruNameFor/?partNo=${partNo}` )
            .map(( response: Response ) => <IReturnObject>response.json() );
    }

    searchPart(searchString: string, searchInDescription: boolean): Observable<IReturnObject> {
        return this.http.get( `${this.apiUrl}/SearchPart/?searchString=${searchString}&searchInDescription=${searchInDescription}`)
            .map((response: Response) => <IReturnObject>response.json());  
    }
    
    getPart( partId: number ): Observable<IReturnObject> {
        return this.http.get( `${this.apiUrl}/GetPart/?partId=${partId}` )
            .map(( response: Response ) => <IReturnObject>response.json() );
    }
    getPartList( partIds: Array<number> ): Observable<IReturnObject> {
        return this.http.get( `${this.apiUrl}/GetPartList/?partIds=${partIds.join(',')}` )
            .map(( response: Response ) => <IReturnObject>response.json() );
    }

    getPartInfo( partId: number ): Observable<IReturnObject> {
        return this.http.get( `${this.apiUrl}/GetPartInfo/?partId=${partId}` )
            .map(( response: Response ) => <IReturnObject>response.json() );
    }
}



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/partsupplierpru/partsupplierpru.service.ts